import React from 'react'

import styled from 'styled-components'

import { style } from 'theme'

import { TestIDs } from '../../test/utils/testIds'

export const REFERRAL_BANNER_HEIGHT = 44

type Props = {
  amount: number
}

const Banner = styled.div`
  align-items: center;
  background-color: ${style(theme => theme.colors.green)}
  color: white;
  display: flex;
  height: ${REFERRAL_BANNER_HEIGHT}px;
  justify-content: center
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
`

const BannerText = styled.span`
  color: white;
  font-weight: 500;
`

const ReferralBanner: React.SFC<Props> = ({ amount }) => (
  <Banner>
    <BannerText data-testid={TestIDs.REFERRAL_BANNER.BANNER_TXT}>
      Get ${amount} after you make your 1st investment.
    </BannerText>
  </Banner>
)

export default ReferralBanner
